import React from 'react';

export const BoardBackground: React.FC<React.SVGProps<SVGSVGElement>> = ({ fill = "#ffffff" }) => {
  return (
    <svg version="1.1" viewBox="0 0 119.06 119.06" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path transform="scale(.26458)" d="m153 1.4492c-1.3055 0-1.4863 1.8145-1.4863 1.8145v222.04 221.65s0.18079 1.8144 1.4863 1.8144c1.3056 0 1.4863-1.8144 1.4863-1.8144v-221.65-222.04s-0.18078-1.8145-1.4863-1.8145z" fill={fill}/>
        <path d="m78.544 0.38344c-0.34542 0-0.39326 0.48007-0.39326 0.48007v117.39s0.04783 0.48007 0.39326 0.48007c0.34543 0 0.39326-0.48007 0.39326-0.48007v-117.39s-0.04783-0.48007-0.39326-0.48007z" fill={fill}/>
        <path d="m0.35502 78.908c0 0.34542 0.48007 0.39326 0.48007 0.39326h117.39s0.48007-0.04783 0.48007-0.39326c0-0.34543-0.48007-0.39326-0.48007-0.39326h-117.39s-0.48007 0.04783-0.48007 0.39326z" fill={fill}/>
        <path d="m0.35502 40.476c0 0.34542 0.48007 0.39326 0.48007 0.39326h117.39s0.48007-0.04783 0.48007-0.39326c0-0.34543-0.48007-0.39326-0.48007-0.39326h-117.39s-0.48007 0.04783-0.48007 0.39326z" fill={fill}/>
      </g>
    </svg>
  );
};